export default __webpack_public_path__ + "static/media/Ies_Panel2_ENG_movil.841200a6.jpg";